// © 2026 KaraokeClubs. All rights reserved.

"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface to the console; GlitchTip/Sentry can pick this up if wired.
    console.error(error);
  }, [error]);

  return (
    <main className="min-h-[100dvh] flex flex-col items-center justify-center text-center px-6 mesh-bg">
      <div className="w-16 h-16 mb-5 rounded-2xl bg-gradient-to-br from-rose-500/25 to-fuchsia-500/20 border border-rose-500/20 flex items-center justify-center text-3xl">
        🎤
      </div>
      <h1 className="text-2xl font-extrabold tracking-tight text-gradient mb-1">
        Something went off-key
      </h1>
      <p className="text-sm text-zinc-400 mb-6 max-w-xs">
        An unexpected error occurred. Try again in a moment.
      </p>
      <button
        onClick={reset}
        className="px-5 py-2 rounded-full text-sm font-semibold text-violet-300 bg-violet-500/10 border border-violet-500/20 hover:bg-violet-500/20 transition-colors"
      >
        Try again
      </button>
    </main>
  );
}
